import { Content } from "src/shared/components/content";

export const TicketToFreedom = () => (
  <svg version="1.1" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>
      <Content id="cid$#2984762#" />
    </title>
    <defs>
      <circle id="a" cx="100" cy="100" r="100" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-60 -292)">
        <g transform="translate(60 292)">
          <mask id="b" fill="white">
            <use xlinkHref="#a" />
          </mask>
          <use fill="#E8F4D9" xlinkHref="#a" />
          <g mask="url(#b)">
            <g transform="translate(59 57)">
              <g transform="translate(0 21.172)" stroke="#8CC63F">
                <path
                  d="m35.802 6.3795c0 3.2869 2.6597 5.8002 6.1376 5.8002s6.1375-2.5134 6.1375-5.8002h9.2063l-1.375e-4 42.857h-30.688l3.068e-4 -42.857h9.2063z"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  x1="73.651"
                  x2="82.857"
                  y1="19.645"
                  y2="19.645"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  x1="73.651"
                  x2="80.987"
                  y1="7.575"
                  y2=".25703"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  transform="translate(77.319 36.394) scale(-1 1) rotate(135) translate(-77.319 -36.394)"
                  x1="72.138"
                  x2="82.5"
                  y1="36.388"
                  y2="36.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  transform="translate(4.6032 19.645) scale(-1 1) translate(-4.6032 -19.645)"
                  x2="9.2063"
                  y1="19.645"
                  y2="19.645"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  transform="translate(5.5384 3.916) scale(-1 1) rotate(-45) translate(-5.5384 -3.916)"
                  x1=".35743"
                  x2="10.719"
                  y1="3.9096"
                  y2="3.9224"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  x1="9.2063"
                  x2="1.8703"
                  y1="32.735"
                  y2="40.053"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  x1="33.25"
                  x2="49.528"
                  y1="21.236"
                  y2="21.236"
                  strokeLinecap="round"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  x1="33.25"
                  x2="49.528"
                  y1="27.481"
                  y2="27.481"
                  strokeLinecap="round"
                  strokeWidth="4.0816"
                />
                <line
                  id="Path"
                  x1="33.25"
                  x2="49.528"
                  y1="33.727"
                  y2="33.727"
                  strokeLinecap="round"
                  strokeWidth="4.0816"
                />
              </g>
              <g transform="translate(17.39)" stroke="#264A19" strokeLinejoin="round" strokeWidth="4.0816">
                <path
                  id="Path"
                  d="m47.829 78.261c0 4.0994-3.3112 7.4535-7.3582 7.4535h-33.112c-4.047 0-7.3582-3.3541-7.3582-7.4535v-70.807c0-4.0993 3.3112-7.4534 7.3582-7.4534h33.112c4.047 0 7.3582 3.3541 7.3582 7.4534v70.807z"
                  strokeLinecap="round"
                />
                <line id="Path" x1="47.829" y1="14.907" y2="14.907" strokeLinecap="round" />
                <line id="Path" x1="47.829" y1="70.408" y2="70.408" strokeLinecap="round" />
                <line id="c" x1="14.717" x2="33.112" y1="7.4534" y2="7.4534" strokeLinecap="round" />
                <path d="m25.754 78.261c0 1.118-0.73579 1.8634-1.8395 1.8634s-1.8395-0.74541-1.8395-1.8634c0-1.1181 0.73579-1.8634 1.8395-1.8634s1.8395 0.74531 1.8395 1.8634z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
